import { ComboBoxItem } from '../types/comboBoxItem'

export const getItemFromValue = (value: string): ComboBoxItem => ({
  id: value,
  children: value,
  value: {
    displayData: { title: '' },
    value,
  },
})
